import { TApiResponse } from '@/common/types/response';

import { TProjectWithNationsState } from './types';

export function setListOfProjects(
  state: TProjectWithNationsState,
  res: TApiResponse<TProjectWithNationsState['listOfProjects']>,
) {
  state.listOfProjects = res.data;
}

export function setProjectsInForeignCountriesDatesCount(
  state: TProjectWithNationsState,
  res: TApiResponse<TProjectWithNationsState['projectsInForeignCountriesDatesCount']>,
) {
  state.projectsInForeignCountriesDatesCount = res.data;
}

export function setIsLoadingCount(state: TProjectWithNationsState, isLoading: boolean) {
  state.isLoadingCount = isLoading;
}
